



















/**
 * 名称：
 * パンくず
 */
import Vue, { PropType } from "vue"
import MaterialIcon, {
  OUTLINED,
} from "~/components/guideline/icon/MaterialIcon.vue"

export interface BreadcrumbItem {
  href?: string
  text: string
}

export default Vue.extend({
  components: {
    MaterialIcon,
  },
  props: {
    /**
     * パンくずの内容
     */
    items: {
      type: Array as PropType<BreadcrumbItem[]>,
      required: true,
    },
  },
  computed: {
    iconType() {
      return { OUTLINED }
    },
  },
})
